import { object, string, number, array, boolean } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { isDateBiggerOrEqual } from '~/utils/date';
import { PatientSelectorType } from '../enums';

const validationSchema = object().shape({
  selectorType: string().required('Field is required'),
  programId: number()
    .nullable()
    .when('selectorType', {
      is: PatientSelectorType.Program,
      then: schema => schema.required('Field is required'),
    }),
  healthManagerId: number()
    .nullable()
    .when('selectorType', {
      is: PatientSelectorType.HealthManager,
      then: schema => schema.required('Field is required'),
    }),
  patientIds: array().of(number()).min(1, 'Field is required'),
  includeReadings: boolean(),
  includeCharts: boolean(),
  includeNotes: boolean(),
  startDate: string().required('Field is required'),
  endDate: string()
    .required('Field is required')
    .test({
      name: 'dateCompare',
      message: '`End date` should be equal or bigger then `Start date`',
      test: (value, context) => {
        // eslint-disable-next-line
        const { startDate } = context.parent;
        if (!startDate || !value) return true;
        return isDateBiggerOrEqual(startDate, value);
      },
    }),
});

export default yupResolver(validationSchema);
